import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import {
  faLightbulbOn,
  faBullseyeArrow,
  faRoute,
} from '@fortawesome/pro-solid-svg-icons';
import { MapButton } from 'src/components/MapButton';

interface StrategyReferralInfoProps {
  showMapButton?: boolean;
  description: string;
  title: string;
  isEngageStrategy?: boolean;
  isPatientJourney?: boolean;
}

const StrategyReferralInfo = ({
  showMapButton = false,
  description = '',
  title = '',
  isEngageStrategy = false,
  isPatientJourney = false,
}: StrategyReferralInfoProps) => {
  return (
    <div className="flex-1 flex flex-col justify-center items-start gap-0.5">
      <div className="flex items-center gap-1.5">
        {(isEngageStrategy || isPatientJourney) && (
          <div className="w-5 h-5 flex items-center justify-center">
            <Icon
              icon={isPatientJourney ? faRoute : faLightbulbOn}
              className="w-4 h-4 text-secondary"
            />
          </div>
        )}
        <div className="text-primary text-lg font-bold font-['Inter'] leading-7">
          {title}
          {isPatientJourney && <sup>*</sup>}
        </div>
        {isEngageStrategy && (
          <div className="px-1.5 py-1 bg-neutral-100 rounded-md flex justify-center items-center gap-0.5 overflow-hidden">
            <div className="w-3 h-3 flex items-center justify-center">
              <Icon
                icon={faBullseyeArrow}
                size="xs"
                className="w-2 h-2 text-secondary"
              />
            </div>
            <div className="text-center justify-start text-secondary text-xs font-normal font-['Inter'] leading-4">
              Radius-Based Analysis
            </div>
          </div>
        )}
        {showMapButton && (
          <div className="flex-1 flex justify-end">
            <MapButton
              onClick={() => {
                // TODO: update onClick functionality here to navigate to associated strategy profile strategy tab (map view)
                console.log('clicked');
              }}
            />
          </div>
        )}
      </div>
      <div className="self-stretch justify-start text-gray-600 text-sm font-normal font-['Inter'] leading-5">
        {description}
      </div>
    </div>
  );
};

export default StrategyReferralInfo;
